import { useMatches } from "react-router";

function useRouteHandle(name: string): string | null {
    const matches = useMatches();

    const route = matches.at(-1);

    if (!route?.handle) {
        return null;
    }

    const value = (route.handle as Record<string, unknown>)[name];

    return typeof value === "string" ? value : null;
}

export function useRouteTrackingName(): string | null {
    return useRouteHandle("trackingName");
}
